<template>
  <Transition name="bubble">
    <div v-if="isThinking" class="plr-character-status-bubble">
      <svg
        width="206"
        height="206"
        viewBox="0 0 206 206"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="bubble_3"
          d="M86.5786 140.003C77.8918 142.887 69.5785 146.003 62.0785 138.003C54.5785 130.003 56.842 120.112 64.5784 115.003C72.3148 109.894 81.8044 112.432 89.4415 119.967C97.0786 127.503 95.2655 137.118 86.5786 140.003Z"
          fill="white"
        />
        <path
          id="bubble_2"
          d="M70.64 153.538C70.1817 159.038 66.14 162.538 60.14 163.538C54.14 164.538 51.1404 158.538 50.14 153.038C49.1396 147.538 53.64 144.538 59.14 144.038C64.64 143.538 71.0983 148.038 70.64 153.538Z"
          fill="white"
        />
        <path
          id="bubble_1"
          d="M52.5771 172C52.0767 175 49.5771 176.5 47.5771 176.5C45.577 176.5 43.5768 174 43.0771 171.5C42.5773 169 44.5767 167 47.0771 167C49.5774 167 53.0774 169 52.5771 172Z"
          fill="white"
        />
        <path
          id="bubble_0"
          d="M15 72.152C14.9989 45.7035 33 38.4853 41 38.152C41 32.1509 52.0005 12.1509 73.9998 24.1517C76.5005 -6.84853 135.5 -3.84912 148.5 33.652C190.5 -2.34835 204 83.6517 164.5 85.1517C175.001 118.151 119 130.152 108 108.152C81.5005 129.152 50.5005 109.652 50.5005 94.1517C32.001 94.1517 15.0007 88.6517 15 72.152Z"
          fill="white"
        />
        <path
          class="char"
          id="char_1"
          d="M131.724 74.0158C130.749 74.0158 130.033 73.9208 129.577 73.7308C129.121 73.5408 128.893 73.2875 128.893 72.9708C128.893 72.7681 128.956 72.6035 129.083 72.4768C129.222 72.3501 129.393 72.2868 129.596 72.2868C129.811 72.2868 130.122 72.3185 130.527 72.3818C130.932 72.4578 131.331 72.4958 131.724 72.4958C133.029 72.4958 134.099 72.1095 134.935 71.3368C135.771 70.5641 136.411 69.3798 136.854 67.7838C137.297 66.1751 137.595 64.1231 137.747 61.6278C137.367 62.4005 136.936 63.1731 136.455 63.9458C135.986 64.7058 135.48 65.4025 134.935 66.0358C134.403 66.6565 133.852 67.1568 133.282 67.5368C132.712 67.9168 132.148 68.1068 131.591 68.1068C131.059 68.1068 130.666 67.9738 130.413 67.7078C130.172 67.4418 130.052 67.0048 130.052 66.3968C130.052 65.8521 130.204 65.2758 130.508 64.6678C130.812 64.0471 131.217 63.4265 131.724 62.8058C132.231 62.1851 132.788 61.5961 133.396 61.0388C134.004 60.4688 134.612 59.9685 135.22 59.5378C135.841 59.0945 136.417 58.7461 136.949 58.4928C137.481 58.2395 137.912 58.1128 138.241 58.1128C138.57 58.1128 138.824 58.2268 139.001 58.4548C139.178 58.6828 139.267 59.1135 139.267 59.7468C139.267 61.2288 139.216 62.6728 139.115 64.0788C139.026 65.4721 138.843 66.7705 138.564 67.9738C138.285 69.1771 137.867 70.2285 137.31 71.1278C136.765 72.0398 136.037 72.7491 135.125 73.2558C134.213 73.7625 133.079 74.0158 131.724 74.0158ZM137.405 59.7658C136.772 60.1711 136.119 60.6271 135.448 61.1338C134.777 61.6405 134.15 62.1788 133.567 62.7488C132.997 63.3188 132.535 63.9078 132.18 64.5158C131.825 65.1238 131.648 65.7318 131.648 66.3398C131.648 66.5298 131.768 66.6248 132.009 66.6248C132.199 66.6248 132.459 66.4791 132.788 66.1878C133.13 65.8838 133.51 65.4848 133.928 64.9908C134.346 64.4841 134.77 63.9331 135.201 63.3378C135.644 62.7298 136.056 62.1155 136.436 61.4948C136.816 60.8741 137.139 60.2978 137.405 59.7658Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_2"
          d="M117.344 68.5632C116.976 68.5632 116.647 68.3542 116.356 67.9362C116.064 67.5182 115.919 66.9799 115.919 66.3212C115.919 65.5992 116.014 64.8265 116.204 64.0032C116.406 63.1799 116.653 62.3439 116.945 61.4952C117.236 60.6339 117.521 59.8042 117.8 59.0062C117.863 58.8415 117.952 58.7212 118.066 58.6452C118.192 58.5565 118.382 58.5122 118.636 58.5122C119.092 58.5122 119.32 58.7339 119.32 59.1772C119.32 59.2785 119.269 59.5065 119.168 59.8612C119.066 60.2159 118.933 60.6529 118.769 61.1722C118.617 61.6915 118.458 62.2552 118.294 62.8632C118.129 63.4585 117.983 64.0602 117.857 64.6682C117.73 65.2762 117.641 65.8399 117.591 66.3592C117.793 66.1439 118.021 65.8145 118.275 65.3712C118.541 64.9279 118.826 64.4275 119.13 63.8702C119.434 63.3002 119.75 62.7302 120.08 62.1602C120.409 61.5775 120.738 61.0455 121.068 60.5642C121.41 60.0702 121.739 59.6775 122.056 59.3862C122.385 59.0822 122.689 58.9302 122.968 58.9302C123.373 58.9302 123.715 59.0569 123.994 59.3102C124.285 59.5509 124.507 59.9815 124.659 60.6022C124.823 61.2102 124.906 62.0715 124.906 63.1862C124.906 63.7815 124.963 64.3389 125.077 64.8582C125.203 65.3775 125.4 65.7955 125.666 66.1122C125.944 66.4162 126.299 66.5682 126.73 66.5682C127.376 66.5682 127.952 66.4542 128.459 66.2262C128.965 65.9855 129.402 65.7195 129.77 65.4282C130.15 65.1242 130.466 64.8582 130.72 64.6302C130.973 64.3895 131.169 64.2692 131.309 64.2692C131.6 64.2692 131.746 64.4212 131.746 64.7252C131.746 64.8519 131.651 65.0545 131.461 65.3332C131.283 65.5992 131.03 65.9032 130.701 66.2452C130.384 66.5745 130.017 66.8975 129.599 67.2142C129.193 67.5182 128.756 67.7715 128.288 67.9742C127.832 68.1769 127.369 68.2782 126.901 68.2782C126.027 68.2782 125.311 68.1072 124.754 67.7652C124.209 67.4232 123.804 66.8595 123.538 66.0742C123.284 65.2889 123.158 64.2375 123.158 62.9202C123.158 62.1982 123.113 61.6725 123.025 61.3432C122.949 61.0012 122.803 60.7732 122.588 60.6592C122.436 60.9252 122.239 61.3052 121.999 61.7992C121.758 62.2805 121.479 62.8189 121.163 63.4142C120.859 64.0095 120.536 64.6112 120.194 65.2192C119.864 65.8145 119.529 66.3655 119.187 66.8722C118.845 67.3789 118.515 67.7905 118.199 68.1072C117.882 68.4112 117.597 68.5632 117.344 68.5632Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_3"
          d="M111.198 69.0951C110.958 69.0951 110.742 69.0064 110.552 68.8291C110.362 68.6391 110.267 68.3477 110.267 67.9551C110.267 67.6764 110.305 67.2901 110.381 66.7961C110.457 66.2894 110.559 65.7384 110.685 65.1431C110.812 64.5477 110.945 63.9587 111.084 63.3761C111.236 62.7807 111.388 62.2487 111.54 61.7801C111.692 61.3114 111.825 60.9631 111.939 60.7351C112.041 60.5577 112.136 60.4437 112.224 60.3931C112.326 60.3424 112.421 60.3171 112.509 60.3171C112.687 60.3171 112.839 60.3741 112.965 60.4881C113.105 60.6021 113.174 60.8237 113.174 61.1531C113.174 61.3431 113.136 61.6597 113.06 62.1031C112.997 62.5337 112.908 63.0404 112.794 63.6231C112.693 64.1931 112.579 64.7821 112.452 65.3901C112.338 65.9854 112.224 66.5554 112.11 67.1001C111.996 67.6447 111.908 68.1007 111.844 68.4681C111.794 68.6707 111.705 68.8291 111.578 68.9431C111.464 69.0444 111.338 69.0951 111.198 69.0951ZM113.06 58.5881C112.769 58.5881 112.49 58.4994 112.224 58.3221C111.971 58.1447 111.844 57.8597 111.844 57.4671C111.844 57.1377 111.92 56.8717 112.072 56.6691C112.237 56.4664 112.427 56.3207 112.642 56.2321C112.87 56.1307 113.067 56.0801 113.231 56.0801C113.396 56.0801 113.58 56.1181 113.782 56.1941C113.998 56.2574 114.181 56.3841 114.333 56.5741C114.485 56.7514 114.561 57.0174 114.561 57.3721C114.561 57.6127 114.479 57.8281 114.314 58.0181C114.15 58.1954 113.947 58.3347 113.706 58.4361C113.478 58.5374 113.263 58.5881 113.06 58.5881Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_4"
          d="M104.279 70.0071C103.456 70.0071 102.696 69.8108 101.999 69.4181C101.315 69.0255 100.694 68.5188 100.137 67.8981C99.5924 67.2775 99.1048 66.6125 98.6741 65.9031C98.2561 65.1811 97.8951 64.5035 97.5911 63.8701C97.3758 64.8961 97.2048 65.7258 97.0781 66.3591C96.9641 66.9925 96.8691 67.4738 96.7931 67.8031C96.7298 68.1325 96.6664 68.3541 96.6031 68.4681C96.5398 68.5821 96.4574 68.6391 96.3561 68.6391C96.0774 68.6391 95.8114 68.4871 95.5581 68.1831C95.3048 67.8791 95.1781 67.4865 95.1781 67.0051C95.1781 66.4985 95.2668 65.8271 95.4441 64.9911C95.6214 64.1425 95.8558 63.2051 96.1471 62.1791C96.4511 61.1405 96.7994 60.0701 97.1921 58.9681C97.5848 57.8535 97.9901 56.7705 98.4081 55.7191C98.8388 54.6551 99.2694 53.6861 99.7001 52.8121C99.9154 52.3815 100.099 52.1028 100.251 51.9761C100.416 51.8495 100.612 51.7861 100.84 51.7861C101.207 51.7861 101.391 51.9571 101.391 52.2991C101.391 52.4258 101.353 52.5651 101.277 52.7171C101.214 52.8691 101.144 53.0401 101.068 53.2301C100.84 53.7875 100.587 54.4145 100.308 55.1111C100.042 55.8078 99.7698 56.5361 99.4911 57.2961C99.2251 58.0561 98.9718 58.8098 98.7311 59.5571C98.4904 60.3045 98.2814 60.9948 98.1041 61.6281C98.6488 61.2481 99.2884 60.8681 100.023 60.4881C100.758 60.1081 101.518 59.7661 102.303 59.4621C103.088 59.1455 103.829 58.8921 104.526 58.7021C105.223 58.5121 105.799 58.4171 106.255 58.4171C106.496 58.4171 106.679 58.4931 106.806 58.6451C106.945 58.7845 107.015 58.9428 107.015 59.1201C107.015 59.2595 106.971 59.3988 106.882 59.5381C106.806 59.6648 106.641 59.7788 106.388 59.8801C105.552 60.1715 104.722 60.4691 103.899 60.7731C103.076 61.0645 102.214 61.3811 101.315 61.7231C100.428 62.0525 99.4594 62.4451 98.4081 62.9011C98.7374 63.4585 99.1238 64.0601 99.5671 64.7061C100.01 65.3395 100.485 65.9411 100.992 66.5111C101.499 67.0685 102.018 67.5308 102.55 67.8981C103.082 68.2528 103.614 68.4301 104.146 68.4301C104.843 68.4301 105.514 68.2845 106.16 67.9931C106.806 67.7018 107.401 67.3471 107.946 66.9291C108.503 66.5111 108.991 66.1058 109.409 65.7131C109.827 65.3078 110.156 64.9911 110.397 64.7631C110.524 64.6491 110.638 64.5731 110.739 64.5351C110.853 64.4845 110.954 64.4591 111.043 64.4591C111.22 64.4591 111.341 64.5541 111.404 64.7441C111.48 64.9215 111.417 65.1178 111.214 65.3331C111.062 65.5105 110.828 65.7828 110.511 66.1501C110.194 66.5175 109.808 66.9228 109.352 67.3661C108.909 67.7968 108.415 68.2148 107.87 68.6201C107.338 69.0255 106.762 69.3548 106.141 69.6081C105.533 69.8741 104.912 70.0071 104.279 70.0071Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_5"
          d="M82.0898 68.5632C81.7225 68.5632 81.3931 68.3542 81.1018 67.9362C80.8105 67.5182 80.6648 66.9799 80.6648 66.3212C80.6648 65.5992 80.7598 64.8265 80.9498 64.0032C81.1525 63.1799 81.3995 62.3439 81.6908 61.4952C81.9821 60.6339 82.2671 59.8042 82.5458 59.0062C82.6091 58.8415 82.6978 58.7212 82.8118 58.6452C82.9385 58.5565 83.1285 58.5122 83.3818 58.5122C83.8378 58.5122 84.0658 58.7339 84.0658 59.1772C84.0658 59.2785 84.0151 59.5065 83.9138 59.8612C83.8125 60.2159 83.6795 60.6529 83.5148 61.1722C83.3628 61.6915 83.2045 62.2552 83.0398 62.8632C82.8751 63.4585 82.7295 64.0602 82.6028 64.6682C82.4761 65.2762 82.3875 65.8399 82.3368 66.3592C82.5395 66.1439 82.7675 65.8145 83.0208 65.3712C83.2868 64.9279 83.5718 64.4275 83.8758 63.8702C84.1798 63.3002 84.4965 62.7302 84.8258 62.1602C85.1551 61.5775 85.4845 61.0455 85.8138 60.5642C86.1558 60.0702 86.4851 59.6775 86.8018 59.3862C87.1311 59.0822 87.4351 58.9302 87.7138 58.9302C88.1191 58.9302 88.4611 59.0569 88.7398 59.3102C89.0311 59.5509 89.2528 59.9815 89.4048 60.6022C89.5695 61.2102 89.6518 62.0715 89.6518 63.1862C89.6518 63.7815 89.7088 64.3389 89.8228 64.8582C89.9495 65.3775 90.1458 65.7955 90.4118 66.1122C90.6905 66.4162 91.0451 66.5682 91.4758 66.5682C92.1218 66.5682 92.6981 66.4542 93.2048 66.2262C93.7115 65.9855 94.1485 65.7195 94.5158 65.4282C94.8958 65.1242 95.2125 64.8582 95.4658 64.6302C95.7191 64.3895 95.9155 64.2692 96.0548 64.2692C96.3461 64.2692 96.4918 64.4212 96.4918 64.7252C96.4918 64.8519 96.3968 65.0545 96.2068 65.3332C96.0295 65.5992 95.7761 65.9032 95.4468 66.2452C95.1301 66.5745 94.7628 66.8975 94.3448 67.2142C93.9395 67.5182 93.5025 67.7715 93.0338 67.9742C92.5778 68.1769 92.1155 68.2782 91.6468 68.2782C90.7728 68.2782 90.0571 68.1072 89.4998 67.7652C88.9551 67.4232 88.5498 66.8595 88.2838 66.0742C88.0305 65.2889 87.9038 64.2375 87.9038 62.9202C87.9038 62.1982 87.8595 61.6725 87.7708 61.3432C87.6948 61.0012 87.5491 60.7732 87.3338 60.6592C87.1818 60.9252 86.9855 61.3052 86.7448 61.7992C86.5041 62.2805 86.2255 62.8189 85.9088 63.4142C85.6048 64.0095 85.2818 64.6112 84.9398 65.2192C84.6105 65.8145 84.2748 66.3655 83.9328 66.8722C83.5908 67.3789 83.2615 67.7905 82.9448 68.1072C82.6281 68.4112 82.3431 68.5632 82.0898 68.5632Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_6"
          d="M75.9445 69.0951C75.7038 69.0951 75.4885 69.0064 75.2985 68.8291C75.1085 68.6391 75.0135 68.3477 75.0135 67.9551C75.0135 67.6764 75.0515 67.2901 75.1275 66.7961C75.2035 66.2894 75.3048 65.7384 75.4315 65.1431C75.5582 64.5477 75.6912 63.9587 75.8305 63.3761C75.9825 62.7807 76.1345 62.2487 76.2865 61.7801C76.4385 61.3114 76.5715 60.9631 76.6855 60.7351C76.7868 60.5577 76.8818 60.4437 76.9705 60.3931C77.0718 60.3424 77.1668 60.3171 77.2555 60.3171C77.4328 60.3171 77.5848 60.3741 77.7115 60.4881C77.8508 60.6021 77.9205 60.8237 77.9205 61.1531C77.9205 61.3431 77.8825 61.6597 77.8065 62.1031C77.7432 62.5337 77.6545 63.0404 77.5405 63.6231C77.4392 64.1931 77.3252 64.7821 77.1985 65.3901C77.0845 65.9854 76.9705 66.5554 76.8565 67.1001C76.7425 67.6447 76.6538 68.1007 76.5905 68.4681C76.5398 68.6707 76.4512 68.8291 76.3245 68.9431C76.2105 69.0444 76.0838 69.0951 75.9445 69.0951ZM77.8065 58.5881C77.5152 58.5881 77.2365 58.4994 76.9705 58.3221C76.7172 58.1447 76.5905 57.8597 76.5905 57.4671C76.5905 57.1377 76.6665 56.8717 76.8185 56.6691C76.9832 56.4664 77.1732 56.3207 77.3885 56.2321C77.6165 56.1307 77.8128 56.0801 77.9775 56.0801C78.1422 56.0801 78.3258 56.1181 78.5285 56.1941C78.7438 56.2574 78.9275 56.3841 79.0795 56.5741C79.2315 56.7514 79.3075 57.0174 79.3075 57.3721C79.3075 57.6127 79.2252 57.8281 79.0605 58.0181C78.8958 58.1954 78.6932 58.3347 78.4525 58.4361C78.2245 58.5374 78.0092 58.5881 77.8065 58.5881Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_7"
          d="M59.9119 69.8549C59.6332 69.8549 59.4179 69.7726 59.2659 69.6079C59.1139 69.4559 59.0379 69.0696 59.0379 68.4489C59.0379 67.8789 59.1392 67.1379 59.3419 66.2259C59.5446 65.3012 59.8169 64.2752 60.1589 63.1479C60.5009 62.0206 60.8872 60.8552 61.3179 59.6519C61.7486 58.4359 62.1982 57.2452 62.6669 56.0799C63.1482 54.9019 63.6106 53.8252 64.0539 52.8499C64.2186 52.4952 64.3896 52.2482 64.5669 52.1089C64.7442 51.9696 64.9532 51.8999 65.1939 51.8999C65.3586 51.8999 65.4979 51.9506 65.6119 52.0519C65.7386 52.1406 65.8019 52.2926 65.8019 52.5079C65.8019 52.5839 65.7196 52.8309 65.5549 53.2489C65.4029 53.6669 65.1876 54.2179 64.9089 54.9019C64.6429 55.5859 64.3452 56.3522 64.0159 57.2009C63.6866 58.0496 63.3509 58.9426 63.0089 59.8799C62.6669 60.8172 62.3439 61.7609 62.0399 62.7109C61.7359 63.6482 61.4762 64.5476 61.2609 65.4089C61.0456 66.2702 60.8999 67.0429 60.8239 67.7269C61.1279 67.3596 61.4762 66.8909 61.8689 66.3209C62.2616 65.7509 62.6796 65.1366 63.1229 64.4779C63.5662 63.8192 64.0159 63.1669 64.4719 62.5209C64.9279 61.8749 65.3776 61.2859 65.8209 60.7539C66.2642 60.2219 66.6759 59.7976 67.0559 59.4809C67.4486 59.1516 67.7906 58.9869 68.0819 58.9869C68.5632 58.9869 68.9496 59.1389 69.2409 59.4429C69.5449 59.7342 69.6969 60.2156 69.6969 60.8869C69.6969 61.2669 69.6209 61.7229 69.4689 62.2549C69.3296 62.7869 69.1649 63.3442 68.9749 63.9269C68.7849 64.5096 68.6139 65.0669 68.4619 65.5989C68.3226 66.1309 68.2529 66.5869 68.2529 66.9669C68.2529 67.4862 68.4492 67.7459 68.8419 67.7459C69.4499 67.7459 70.0579 67.6129 70.6659 67.3469C71.2866 67.0809 71.8756 66.7516 72.4329 66.3589C72.9902 65.9536 73.5032 65.5482 73.9719 65.1429C74.4406 64.7249 74.8396 64.3702 75.1689 64.0789C75.5236 63.7622 75.8212 63.6039 76.0619 63.6039C76.3659 63.6039 76.5179 63.7622 76.5179 64.0789C76.5179 64.1676 76.4989 64.2689 76.4609 64.3829C76.4229 64.4969 76.3216 64.6426 76.1569 64.8199C75.9542 65.0479 75.6629 65.3456 75.2829 65.7129C74.9156 66.0802 74.4849 66.4729 73.9909 66.8909C73.5096 67.3089 72.9839 67.7016 72.4139 68.0689C71.8566 68.4362 71.2802 68.7402 70.6849 68.9809C70.1022 69.2089 69.5322 69.3229 68.9749 69.3229C68.2149 69.3229 67.6259 69.1076 67.2079 68.6769C66.8026 68.2336 66.5999 67.6256 66.5999 66.8529C66.5999 66.3716 66.6759 65.7889 66.8279 65.1049C66.9799 64.4209 67.1699 63.6989 67.3979 62.9389C67.6386 62.1662 67.8792 61.4126 68.1199 60.6779C67.7146 60.9566 67.2712 61.3746 66.7899 61.9319C66.3212 62.4766 65.8272 63.0972 65.3079 63.7939C64.7886 64.4779 64.2692 65.1746 63.7499 65.8839C63.2432 66.5932 62.7492 67.2519 62.2679 67.8599C61.7992 68.4552 61.3622 68.9366 60.9569 69.3039C60.5516 69.6712 60.2032 69.8549 59.9119 69.8549Z"
          fill="#645DB3"
        />
        <path
          class="char"
          id="char_8"
          d="M46.5117 56.821C45.9924 56.821 45.625 56.7956 45.4097 56.745C45.1944 56.6816 45.0614 56.5993 45.0107 56.498C44.9727 56.3966 44.9537 56.2953 44.9537 56.194C44.9537 56.0546 45.0234 55.928 45.1627 55.814C45.3147 55.6873 45.6187 55.586 46.0747 55.51C46.6574 55.3833 47.3414 55.2566 48.1267 55.13C48.9247 54.9906 49.7734 54.864 50.6727 54.75C51.572 54.6233 52.4714 54.5093 53.3707 54.408C54.2827 54.3066 55.1504 54.2306 55.9737 54.18C56.8097 54.1166 57.5507 54.085 58.1967 54.085C59.058 54.085 59.6407 54.161 59.9447 54.313C60.2614 54.465 60.4197 54.6296 60.4197 54.807C60.4197 54.9716 60.331 55.1236 60.1537 55.263C59.989 55.4023 59.704 55.472 59.2987 55.472C59.134 55.472 58.754 55.51 58.1587 55.586C57.5634 55.6493 56.835 55.738 55.9737 55.852C55.125 55.9533 54.2257 56.0673 53.2757 56.194C53.2124 56.6246 53.1174 57.1946 52.9907 57.904C52.864 58.6006 52.7184 59.367 52.5537 60.203C52.4017 61.039 52.2434 61.8813 52.0787 62.73C51.9267 63.566 51.781 64.345 51.6417 65.067C51.515 65.789 51.4074 66.3843 51.3187 66.853C51.23 67.3216 51.1794 67.6003 51.1667 67.689C51.116 68.0816 51.002 68.3793 50.8247 68.582C50.66 68.772 50.4764 68.867 50.2737 68.867C50.033 68.867 49.8304 68.7656 49.6657 68.563C49.5137 68.3476 49.4377 67.974 49.4377 67.442C49.4377 67.2646 49.4757 66.9226 49.5517 66.416C49.6277 65.8966 49.729 65.2823 49.8557 64.573C49.9824 63.8636 50.1217 63.11 50.2737 62.312C50.4257 61.514 50.5777 60.735 50.7297 59.975C50.8817 59.2023 51.021 58.5056 51.1477 57.885C51.2744 57.2516 51.3694 56.7576 51.4327 56.403C50.432 56.517 49.4884 56.6183 48.6017 56.707C47.7277 56.783 47.031 56.821 46.5117 56.821Z"
          fill="#645DB3"
        />
        <path
          id="dot_3"
          d="M150.246 69.2848C149.967 69.2848 149.695 69.1961 149.429 69.0188C149.175 68.8415 149.049 68.5501 149.049 68.1448C149.049 67.8155 149.131 67.5495 149.296 67.3468C149.46 67.1441 149.65 66.9985 149.866 66.9098C150.081 66.8085 150.271 66.7578 150.436 66.7578C150.6 66.7578 150.784 66.7958 150.987 66.8718C151.202 66.9478 151.386 67.0808 151.538 67.2708C151.69 67.4481 151.766 67.7141 151.766 68.0688C151.766 68.4235 151.614 68.7148 151.31 68.9428C151.006 69.1708 150.651 69.2848 150.246 69.2848Z"
          fill="#645DB3"
        />
        <path
          id="dot_2"
          d="M146.646 69.2848C146.367 69.2848 146.095 69.1961 145.829 69.0188C145.576 68.8415 145.449 68.5501 145.449 68.1448C145.449 67.8155 145.531 67.5495 145.696 67.3468C145.861 67.1441 146.051 66.9985 146.266 66.9098C146.481 66.8085 146.671 66.7578 146.836 66.7578C147.001 66.7578 147.184 66.7958 147.387 66.8718C147.602 66.9478 147.786 67.0808 147.938 67.2708C148.09 67.4481 148.166 67.7141 148.166 68.0688C148.166 68.4235 148.014 68.7148 147.71 68.9428C147.406 69.1708 147.051 69.2848 146.646 69.2848Z"
          fill="#645DB3"
        />
        <path
          id="dot_1"
          d="M143.047 69.2848C142.768 69.2848 142.496 69.1961 142.23 69.0188C141.976 68.8415 141.85 68.5501 141.85 68.1448C141.85 67.8155 141.932 67.5495 142.097 67.3468C142.261 67.1441 142.451 66.9985 142.667 66.9098C142.882 66.8085 143.072 66.7578 143.237 66.7578C143.401 66.7578 143.585 66.7958 143.788 66.8718C144.003 66.9478 144.187 67.0808 144.339 67.2708C144.491 67.4481 144.567 67.7141 144.567 68.0688C144.567 68.4235 144.415 68.7148 144.111 68.9428C143.807 69.1708 143.452 69.2848 143.047 69.2848Z"
          fill="#645DB3"
        />
      </svg>
    </div>
  </Transition>
  <div
    ref="avatarContainer"
    class="talking-head-container position-absolute w-100 h-100"
  />
  <Spinner
    v-if="isLoading"
    class="main-spinner position-absolute"
    style="top: 50%; left: 50%; transform: translate(-50%, -50%)"
  />
  <button
    v-if="config.envMode === 'staging'"
    @click="handleToggleThinkingClick"
    style="position: fixed !important; top: 30px; right: 10px; z-index: 998;"
  >
    {{ isThinking ? "Stop" : "Start" }} thinking
  </button>
</template>

<script lang="ts">
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  watchEffect
} from "vue";
import _ from "lodash";
import { TalkingHead } from "@met4citizen/talkinghead/modules/talkinghead.mjs";
import { HeadAudio } from "@met4citizen/headaudio/modules/headaudio.mjs";
import { useStore } from "vuex";
import {
  RemoteViewConfigDto,
  RequestedAction,
  TelephonyType
} from "@moderrotech/servers-communication-library/src/types";
import Spinner from "@/components/Spinner.vue";
import moment from "moment";
import {
  ResizeObserverEntry,
  useResizeObserver,
  useTimeoutFn,
  useUserMedia
} from "@vueuse/core";
import {
  ClampToEdgeWrapping,
  LinearFilter,
  LinearMipmapLinearFilter,
  Mesh,
  MeshBasicMaterial,
  MeshPhongMaterial,
  MeshStandardMaterial
} from "three";
import imageCompression from "browser-image-compression";
import mime from "mime-types";
import { preloadAvatarGlb } from "@/helpers/avatar";

export default {
  components: { Spinner },

  emits: ["stateChange"],

  setup: function(props: object, context: { emit: Function }) {
    enum PoseName {
      side = "side",
      hip = "hip",
      turn = "turn",
      bend = "bend",
      back = "back",
      straight = "straight",
      wide = "wide",
      oneKnee = "oneknee",
      twoKnees = "kneel",
      sitting = "sitting"
    }
    enum CameraView {
      full = "full",
      upper = "upper",
      head = "head",
      mid = "mid"
    }

    const store = useStore();

    const remoteViewConfig = computed(
        (): RemoteViewConfigDto | null => store.state.session.remoteViewConfig
      ),
      cameraView = computed(
        () =>
          remoteViewConfig.value?.animated_character?.camera_view ??
          CameraView.upper
      );

    const avatarContainer = ref(null),
      ensureIsMounted = () => {
        if (!avatarContainer.value) {
          throw new Error("Component already unmounted");
        }
      };
    let head: any = null,
      headaudio: any = null;

    let micNode: MediaStreamAudioSourceNode | null = null;
    const isLipSyncing = () => !!micNode,
      isSpeaking = ref(false),
      isThinking = ref(false);

    watch(
      () => [isSpeaking.value, isThinking.value],
      ([v1, v2]) => {
        if (!head) {
          return;
        }

        head.isSpeaking = v1; // workaround to force head 'speaking' state

        if (!v1 && !v2) {
          // isThinking.value condition present to avoid canceling 'thinking' animation
          head?.stopSpeaking();
        }
      },
      { immediate: true }
    );

    const isLoading = ref(false);

    const telephonyType = computed(
      (): TelephonyType | null => store.state.telephonyType
    );

    const stream = computed(() =>
      telephonyType.value === TelephonyType.webex
        ? store.state.webex.streams.remoteVideo
        : telephonyType.value === TelephonyType.webrtc
        ? store.state.webrtc.streams.remote
        : null
    );

    // const { stream } = useUserMedia({
    //   enabled: true,
    //   videoDeviceId: false
    // });

    const config = computed(() => store.state.config.config);

    const getFileUrl = (file: string) =>
      `${config.value.publicPath ?? "/"}${file}`;

    const maxInt = Number.MAX_SAFE_INTEGER;

    const targetPose = computed(
        () =>
          isThinking.value
            ? PoseName.straight
            : isSpeaking.value
            ? PoseName.straight
            : _.includes([CameraView.head, CameraView.upper], cameraView.value)
            ? PoseName.straight
            : PoseName.straight //PoseName.side
      ),
      syncPose = async (transition = 1000) => {
        console.log("Syncing avatar pose...", {
          targetPose: targetPose.value,
          transition
        });

        if (head?.poseName === targetPose.value) {
          console.log(`Avatar already in '${targetPose.value}' pose, ignored`);
          return;
        }

        head.poseName = targetPose.value;

        return new Promise((resolve, reject) => {
          if (head?.mixer) {
            head?.mixer.removeEventListener("finished", head?._mixerHandler);
            head?.mixer.stopAllAction();
            head?.mixer.uncacheRoot(head?.armature);
            head.mixer = null;
            head._mixerHandler = null;
          }

          head.animQueue = _.filter(
            head.animQueue,
            x => x.template?.name !== "pose"
          );

          head?.setPoseFromTemplate(
            head?.poseTemplates?.[targetPose.value],
            transition
          );

          window.setTimeout(() => {
            try {
              ensureIsMounted();
              console.log("Avatar pose synced");
              resolve();
            } catch (e) {
              reject();
            }
          }, transition);
        });
      };

    const {
      start: startHeadAudioEndedTimer,
      stop: stopHeadAudioEndedTimer
    } = useTimeoutFn(
      () => {
        if (isSpeaking.value) {
          console.log("Speaking inactive during 1 second, handling");
          isSpeaking.value = false;
          syncPose();
        }
      },
      1000,
      {
        immediate: false
      }
    );

    const startLipSyncing = () => {
        console.log("Starting animated character lip syncing...");

        if (isLipSyncing()) {
          console.log("Animated character lip syncing already started");
          return;
        }

        stopHeadAudioEndedTimer();

        // Resume, if this happens to be the user's first click
        try {
          head?.audioCtx.resume();
        } catch (e) {
          console.error(e);
        }

        micNode = head?.audioCtx.createMediaStreamSource(stream.value!);
        head?.audioSpeechGainNode.disconnect(headaudio);
        micNode?.connect(headaudio);
        headaudio?.resetAll();

        console.log("Animated character lip syncing started");
      },
      stopLipSyncing = () => {
        console.log("Stopping animated character lip syncing...");

        if (!isLipSyncing()) {
          console.log("Animated character lip syncing already stopper");
          return;
        }

        stopHeadAudioEndedTimer();

        if (headaudio) {
          micNode?.disconnect(headaudio);
          head?.audioSpeechGainNode.connect(headaudio);
        }
        micNode = null;
        headaudio?.resetAll();

        isSpeaking.value = false;

        console.log("Animated character lip syncing stopped");
      },
      startThinking = async () => {
        console.log("Starting animated character thinking animation...");

        if (isThinking.value) {
          console.log("Animated character thinking animation already started");
          return;
        }

        stopLipSyncing();

        isThinking.value = true;

        await syncPose(300);

        if (!isThinking.value) {
          console.log(
            "Seems, animated character thinking animation was stopped"
          );
          return;
        }

        const emojiName = "🤔-permanent",
          emoji = _.cloneDeep(head.animEmojis["🤔"]);
        _.set(emoji, "dt.1", maxInt);
        _.set(emoji, "vs.handRight.1.d", maxInt);

        head.animEmojis[emojiName] = emoji;

        //  head?.speakEmoji(emojiName);
        delete head?.animEmojis?.[emojiName];
        head.isSpeaking = false; // workaround to avoid eyes contact and head rotation as during 'speaking' state

        console.log("Animated character thinking animation started");
      },
      stopThinking = () => {
        console.log("Stopping animated character thinking animation...");

        if (!isThinking.value) {
          console.log("Animated character thinking animation already stopped");
          return;
        }

        head?.stopAnimation();

        const emojiName = "🤔-face-release",
          emoji = _.cloneDeep(head.animEmojis["🤔"]);
        _.set(emoji, "dt", [0, 500]);
        _.unset(emoji, "vs.handRight");

        head.animEmojis[emojiName] = emoji;

        //    head?.speakEmoji(emojiName);
        delete head?.animEmojis?.[emojiName];

        isThinking.value = false;
        syncPose();

        console.log("Animated character thinking animation stopped");
      };

    onMounted(async () => {
      const computeView = (container?: Record<"width" | "height", number>) => {
        const isVerticalHead =
          cameraView.value === CameraView.head &&
          container &&
          container.width / container.height < 1;

        return {
          cameraView: cameraView.value,
          modelFPS: 30,
          cameraRotateEnable: false,
          lightAmbientIntensity: 0,
          cameraDistance: isVerticalHead ? 1 : 0,
          cameraY: isVerticalHead ? 0.3 : 0
        };
      };

      const getMeshes = () => {
          const parse = (node: any): Mesh[] =>
            node instanceof Mesh
              ? [node]
              : _.isArray(node?.children)
              ? _.concat([], ..._.map(node?.children, c => parse(c)))
              : [];

          return parse(_.find(head?.scene?.children, "isGroup"));
        },
        findMesh = (name: string) => _.find(getMeshes(), { name }),
        paintMesh = (
          mesh: string | Mesh,
          color: string | [number, number, number]
        ) =>
          _.forEach(
            _.filter(
              _.concat(
                (_.isString(mesh) ? findMesh(mesh) : mesh)?.material ?? []
              ),
              m =>
                m instanceof MeshBasicMaterial ||
                m instanceof MeshStandardMaterial ||
                m instanceof MeshPhongMaterial
                  ? _.isArray(color)
                    ? m?.color?.setRGB(...color)
                    : m?.color?.setHex(
                        parseInt(_.replace(color, "#", "0x"), 16)
                      )
                  : null
            )
          ),
        deleteMesh = (mesh: string | Mesh) => {
          const target = _.isString(mesh) ? findMesh(mesh) : mesh;

          target?.parent?.remove(target);
          target?.geometry.dispose();

          _.isArray(target?.material)
            ? _.forEach(target?.material, m => m.dispose())
            : target?.material?.dispose();
        },
        getTexture = (mesh: string | Mesh) =>
          (_.find(
            _.concat(
              (_.isString(mesh) ? findMesh(mesh) : mesh)?.material ?? []
            ),
            m =>
              (m instanceof MeshBasicMaterial ||
                m instanceof MeshStandardMaterial ||
                m instanceof MeshPhongMaterial) &&
              !!m?.map?.image
          ) as
            | MeshBasicMaterial
            | MeshStandardMaterial
            | MeshPhongMaterial
            | undefined)?.map?.image ?? null,
        changeTexture = (
          mesh: string | Mesh,
          image: string | HTMLImageElement | HTMLCanvasElement
        ) =>
          _.forEach(
            _.concat(
              (_.isString(mesh) ? findMesh(mesh) : mesh)?.material ?? []
            ),
            async m => {
              if (
                !(
                  m instanceof MeshBasicMaterial ||
                  m instanceof MeshStandardMaterial ||
                  m instanceof MeshPhongMaterial
                ) ||
                !m?.map
              ) {
                return;
              }

              m!.depthWrite = true; // Set to true for photos to prevent sorting artifacts
              m!.transparent = true; // Tell Three.js to render the transparent canvas background

              m!.map!.source.data = _.isString(image)
                ? await imageCompression.loadImage(image)
                : image instanceof HTMLCanvasElement
                ? await createImageBitmap(image)
                : image;

              // 1. Fix Photo Artifacts (Use smooth filtering instead of NearestFilter)
              m!.map!.magFilter = LinearFilter;
              m!.map!.minFilter = LinearMipmapLinearFilter; // Smoothes out downscaled high-res photos
              m!.map!.generateMipmaps = true; // Let Three.js build clean downscaled versions

              // 2. Prevent Border Bleeding Artifacts
              m!.map!.wrapS = ClampToEdgeWrapping;
              m!.map!.wrapT = ClampToEdgeWrapping;

              m!.map!.needsUpdate = true;
            }
          );

      isLoading.value = true;

      let logoImg: HTMLImageElement | null = null;

      useResizeObserver(
        avatarContainer.value,
        async (entries: ReadonlyArray<ResizeObserverEntry>) => {
          if (!_.first(entries)) {
            return;
          }

          const view = computeView(entries[0].contentRect);

          if (head) {
            head.setView(view.cameraView, _.omit(view, "cameraView"));
            return;
          }

          head = new TalkingHead(avatarContainer.value, view);

          const avatar = remoteViewConfig.value?.animated_character?.avatar;

          if (!avatar) {
            return;
          }

          const gender =
            "gender" in avatar
              ? avatar?.gender
              : _.first(_.split(avatar?.character, "-")); // male/female

          await Promise.all([
            (async () => {
              await head.audioCtx.audioWorklet.addModule(
                getFileUrl("@met4citizen/headaudio/modules/headworklet.mjs")
              );

              ensureIsMounted();

              headaudio = new HeadAudio(head.audioCtx);

              try {
                await headaudio.loadModel(
                  getFileUrl("@met4citizen/headaudio/dist/model-en-mixed.bin")
                );
              } catch (error) {
                console.error(error);
              }

              ensureIsMounted();

              // Connect speech gain node to lip-sync node + add delay
              head.audioSpeechGainNode.connect(headaudio);
              const delayNode = new DelayNode(head.audioCtx, {
                delayTime: 0.15
              });
              head.audioSpeechGainNode.disconnect(head.audioReverbNode);
              head.audioSpeechGainNode.connect(delayNode);
              delayNode.connect(head.audioReverbNode);

              // Register callback function to set blend shape value
              headaudio.onvalue = (key: string, value: any) => {
                _.assign(head.mtAvatar[key], {
                  newvalue: value,
                  needsUpdate: true
                });
              };

              // Link update method to TalkingHead's animation loop
              head.opt.update = headaudio.update.bind(headaudio);

              // Take eye contact and make a hand gesture when new sentence starts
              let lastEnded = 0;
              headaudio.onended = () => {
                lastEnded = +moment();
                stopHeadAudioEndedTimer();

                if (!isSpeaking.value) {
                  return;
                }

                startHeadAudioEndedTimer();
              };

              headaudio.onstarted = () => {
                stopHeadAudioEndedTimer();

                if (!isSpeaking.value) {
                  isSpeaking.value = true;
                  syncPose();
                }

                const duration = +moment() - lastEnded;
                if (duration > 150) {
                  // New sentence, if 150 ms pause (adjust, if needed)
                  head?.lookAtCamera(500);
                  head?.speakWithHands();
                }
              };
            })(),
            (async () => {
              const url =
                "model" in avatar
                  ? avatar.model
                  : getFileUrl(`avatars/${gender}-merged.glb`);

              try {
                await preloadAvatarGlb(url);
              } catch (err) {
                // Not fatal: showAvatar() falls back to fetching it itself.
                console.error("Model file preloading error: ", {
                  model: url,
                  err
                });
              }

              ensureIsMounted();

              await head.showAvatar(
                {
                  url,
                  body: _.toUpper(_.first(gender)),
                  avatarMood: "neutral",
                  ttsLang: "en-US",
                  ttsVoice: "en-US-Standard-A",
                  avatarSpeakingEyeContact: 1,
                  avatarSpeakingHeadMove: 0
                },
                (ev: any) => {
                  if (ev.lengthComputable) {
                    isLoading.value = ev.loaded < ev.total;
                  }
                }
              );
            })()
          ]);

          ensureIsMounted();

          isLoading.value = false;

          if ("character" in avatar) {
            const meshes = getMeshes(),
              delimiter = "_";

            _.forEach(
              {
                clothes: avatar?.clothes,
                character: avatar?.character,
                hair: avatar?.hair?.style,
                glasses: avatar?.glasses
              },
              (v, k) =>
                _.forEach(
                  _.filter(
                    meshes,
                    (m: Mesh) =>
                      _.startsWith(m.name, `${k}${delimiter}`) &&
                      (_.isNil(v) ||
                        (k === "clothes" &&
                          !avatar?.logo &&
                          !!_.find(
                            ["logo", "badge"],
                            s => m.name === _.join([k, v, s], delimiter)
                          )) ||
                        !(
                          m.name === `${k}${delimiter}${v}` ||
                          _.startsWith(
                            m.name,
                            `${k}${delimiter}${v}${delimiter}`
                          )
                        ))
                  ),
                  (m: Mesh) => deleteMesh(m)
                )
            );

            if (avatar?.clothes && avatar?.logo) {
              (async () => {
                const mesh = findMesh(
                  _.join(["clothes", avatar?.clothes, "logo"], delimiter)
                );

                if (!mesh) {
                  return;
                }

                const texture = getTexture(mesh);

                if (!texture) {
                  return;
                }

                const width = texture?.width ?? 1024,
                  height = texture?.height ?? 1024;

                logoImg =
                  logoImg ??
                  (await imageCompression.loadImage(
                    await imageCompression.getDataUrlFromFile(
                      await (async () => {
                        const blob = await (
                          await fetch(avatar?.logo!, { mode: "cors" })
                        ).blob();

                        return new File(
                          [blob],
                          `file.${mime.extension(blob.type)}`,
                          {
                            type: blob.type,
                            lastModified: +moment()
                          }
                        );
                      })()
                    )
                  ));

                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = width;
                canvas.height = height;
                ctx!.imageSmoothingEnabled = false;
                ctx?.clearRect(0, 0, canvas.width, canvas.height);

                const imgW = logoImg.naturalWidth || logoImg.width,
                  imgH = logoImg.naturalHeight || logoImg.height;

                const padding = findMesh(
                  _.join(["clothes", avatar?.clothes, "badge"], delimiter)
                )
                  ? 0
                  : (_.min([width, height])! * 7) / 100;

                const hRatio = (canvas.width - padding * 2) / imgW,
                  vRatio = (canvas.height - padding * 2) / imgH,
                  ratio = _.min([hRatio, vRatio])!;

                const dx =
                    (canvas.width - padding * 2 - imgW * ratio) / 2 + padding,
                  dy =
                    (canvas.height - padding * 2 - imgH * ratio) / 2 + padding;

                ctx?.drawImage(
                  logoImg,
                  0,
                  0,
                  imgW,
                  imgH,
                  dx,
                  dy,
                  imgW * ratio,
                  imgH * ratio
                );

                changeTexture(mesh, canvas);
              })();
            }

            const hairMesh = (() => {
              if (_.isNil(avatar?.hair?.style)) {
                return null;
              }
              const prefix = `hair${delimiter}${avatar?.hair?.style}`;

              return findMesh(prefix) ?? findMesh(`${prefix}${delimiter}top`);
            })();

            if (hairMesh && avatar?.hair?.color) {
              paintMesh(hairMesh, avatar?.hair?.color);
            }

            const skinColor = _.get(
              {
                "male-3": "#503021",
                "female-3": "#5F3C29"
              },
              avatar?.character ?? "",
              "#F5BDA6"
            ) as string;

            _.forEach(
              _.filter(getMeshes(), m => _.startsWith(m?.name, "hands")),
              m =>
                m?.name ===
                `hands-${
                  gender === "male" &&
                  _.includes(["office-2", "office-3"], avatar?.clothes)
                    ? "avg"
                    : _.find(["casual", "sport"], v =>
                        _.startsWith(avatar?.clothes, v)
                      ) || avatar?.clothes === "office-3"
                    ? "long"
                    : "short"
                }`
                  ? paintMesh(m, skinColor)
                  : deleteMesh(m)
            );
            _.forEach(
              _.filter(getMeshes(), m => _.startsWith(m?.name, "legs")),
              m =>
                m?.name === "legs-short"
                  ? paintMesh(m, skinColor)
                  : deleteMesh(m)
            );
          }

          syncPose();
        }
      );
    });

    onBeforeUnmount(() => stopLipSyncing());

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    watchEffect(() => {
      if (isLoading.value) {
        return;
      }

      if (
        _.findLast(requestedRemoteActions.value, v =>
          _.includes(
            [
              RequestedAction.startThinkingAnimation,
              RequestedAction.stopThinkingAnimation
            ],
            v.action
          )
        )
      ) {
        const isThinkingRequested =
          _.findLast(requestedRemoteActions.value, v =>
            _.includes(
              [
                RequestedAction.startThinkingAnimation,
                RequestedAction.stopThinkingAnimation
              ],
              v.action
            )
          )?.action === RequestedAction.startThinkingAnimation;

        if (isThinkingRequested) {
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.stopThinkingAnimation
          );
          startThinking();
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.startThinkingAnimation
          );
          return;
        } else {
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.startThinkingAnimation
          );
          stopThinking();
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.stopThinkingAnimation
          );
        }
      }

      if (
        _.findLast(requestedRemoteActions.value, {
          action: RequestedAction.interactWithAnimatedCharacterAvatar
        })
      ) {
        const payload = _.findLast(requestedRemoteActions.value, {
          action: RequestedAction.interactWithAnimatedCharacterAvatar
        })?.payload as {
          mood:
            | "neutral"
            | "happy"
            | "angry"
            | "sad"
            | "fear"
            | "disgust"
            | "love"
            | "sleep";
          gesture?:
            | "handup"
            | "index"
            | "ok"
            | "thumbup"
            | "thumbdown"
            | "side"
            | "shrug";
          gaze?: "camera" | "away";
        };

        if (payload?.mood) {
          head?.setMood(payload?.mood);
        }

        if (payload?.gesture) {
          head?.playGesture(payload?.gesture, 2.5);
        }

        if (payload?.gaze) {
          if (payload?.gaze === "camera") {
            head?.makeEyeContact?.(2500);
          } else if (payload?.gaze === "away") {
            head?.lookAhead?.(2000);
          }
        }

        store.commit(
          "session/UNSET_REQUESTED_ACTION",
          RequestedAction.interactWithAnimatedCharacterAvatar
        );
      }

      stream.value ? startLipSyncing() : stopLipSyncing();
    });

    watch(
      () =>
        isThinking.value
          ? "thinking"
          : isSpeaking.value
          ? "speaking"
          : isLoading.value
          ? "loading"
          : "listening",
      v => context.emit("stateChange", v),
      { immediate: true }
    );

    return {
      avatarContainer,
      isLoading,
      isThinking,
      config,
      handleToggleThinkingClick: () =>
        store.commit("session/SET_REQUESTED_ACTION", {
          action: isThinking.value
            ? RequestedAction.stopThinkingAnimation
            : RequestedAction.startThinkingAnimation
        })
    };
  }
};
</script>

<style>
.plr-character-status-bubble {
  position: absolute;
  left: 50%;
  top: 20%;
  z-index: 1000;
  display: inline-block;
  height: 25%;
  width: auto;
  aspect-ratio: 1 / 1;

  svg {
    width: auto;
    height: 100%;
    aspect-ratio: 1 / 1;
    display: inline-block;
    overflow: visible;

    #bubble_0 {
      opacity: 0;
      transform-origin: center center;
      transform: translate(-50px, 68px) scale(0.01);
      animation: bubble_0_animate_pop-in 0.5s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;

      animation-delay: 0.33s;
    }
    #bubble_1 {
      opacity: 0;
      transform-origin: center center;
      transform: translate(-49px, 66px);
      animation: bubble_1_animate_pop-in 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        forwards;
    }
    #bubble_2 {
      opacity: 0;
      transform-origin: center center;
      transform: translate(-20px, 31px);
      animation: bubble_2_animate_pop-in 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        forwards;
    }
    #bubble_3 {
      opacity: 0;
      transform-origin: center center;
      transform: translate(-20px, 20px);
      animation: bubble_3_animate_pop-in 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        forwards;
    }

    #char_1,
    #char_2,
    #char_3,
    #char_4,
    #char_5,
    #char_6,
    #char_7,
    #char_8 {
      opacity: 0;
      animation: animate_chars 0.2s forwards;
    }

    #char_8 {
      animation-delay: 0.75s;
    }
    #char_7 {
      animation-delay: 0.8s;
    }
    #char_6 {
      animation-delay: 0.85s;
    }
    #char_5 {
      animation-delay: 0.9s;
    }
    #char_4 {
      animation-delay: 0.95s;
    }
    #char_3 {
      animation-delay: 1s;
    }
    #char_2 {
      animation-delay: 1.05s;
    }
    #char_1 {
      animation-delay: 1.1s;
    }

    #dot_1 {
      animation: animate_dot1 1.5s infinite;
    }
    #dot_2 {
      animation: animate_dot2 1.5s infinite;
    }
    #dot_3 {
      animation: animate_dot3 1.5s infinite;
    }
    #dot_1,
    #dot_2,
    #dot_3 {
      opacity: 0;
      animation-delay: 1.3s;
    }
  }
}

/* The Keyframe Animation */
@keyframes animate_dot1 {
  0%,
  10% {
    opacity: 0;
  }
  20%,
  100% {
    opacity: 1;
  }
}

@keyframes animate_dot2 {
  0%,
  30% {
    opacity: 0;
  }
  40%,
  100% {
    opacity: 1;
  }
}

@keyframes animate_dot3 {
  0%,
  60% {
    opacity: 0;
  }
  70%,
  100% {
    opacity: 1;
  }
}

@keyframes animate_chars {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes bubble_0_animate_pop-in {
  0% {
    transform: translate(-50px, 68px) scale(0.01);
    opacity: 0;
  }
  4% {
    transform: translate(-50px, 68px) scale(0.01);
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  94% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0) scale(1);
  }
}

@keyframes bubble_3_animate_pop-in {
  0% {
    transform: translate(-20px, 20px);
    opacity: 0;
  }
  30% {
    transform: translate(-20px, 20px);
    opacity: 0;
  }
  78% {
    transform: translate(0, 0);
  }
  85% {
    transform: translate(0, 0);
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes bubble_2_animate_pop-in {
  0% {
    opacity: 0;
    transform: translate(-20px, 31px);
  }
  15% {
    opacity: 0;
    transform: translate(-20px, 31px);
  }
  47% {
    transform: translate(0, 0);
    opacity: 1;
  }
  65% {
    transform: translate(0, 0);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes bubble_1_animate_pop-in {
  0% {
    opacity: 0;
    transform: translate(-49px, 66px);
  }
  4% {
    opacity: 0;
    transform: translate(-49px, 66px);
  }
  30% {
    opacity: 1;
    transform: translate(0, 0);
  }
  62% {
    opacity: 1;
    transform: translate(0, 0);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

.bubble-enter-active,
.bubble-leave-active {
  transition: opacity 0.5s ease;
}

.bubble-enter-from,
.bubble-leave-to {
}

.bubble-enter-to,
.bubble-leave-from {
  opacity: 1;
}

.bubble-enter-from {
}
.bubble-leave-to {
  opacity: 0;
}
</style>
